<script setup lang="ts">
import t from "~/utils/translate";
import { IOutcomeAdditionalInfo } from "~/types/racing/outcome-additional-info";
import Ratings from "~/components/layout/TrackRacing/Shared/Ratings.vue";
import useRacing from "~/composables/TrackRacing/useRacing";
interface OutcomeMetaInfoProps {
	outcomeAdditionalInfo: IOutcomeAdditionalInfo;
}
const { convertJockeyWeight } = useRacing();
defineProps<OutcomeMetaInfoProps>();
</script>

<template>
	<div class="text-xs leading-tight">
		<div v-if="Object.keys(outcomeAdditionalInfo).length">
			<div class="flex items-center justify-between">
				<div>
					<span class="font-bold">{{ t("age") }}</span
					>: {{ outcomeAdditionalInfo.Age }}
				</div>
				<div>
					<span class="font-bold">{{ t("weight") }} </span>: {{ convertJockeyWeight(outcomeAdditionalInfo.Weight) }}
				</div>
				<div>
					<span class="font-bold"> {{ t("form") }}</span
					>: {{ outcomeAdditionalInfo.Form }}
				</div>
			</div>
			<Ratings v-if="+outcomeAdditionalInfo.StarRating" :ratings="+outcomeAdditionalInfo.StarRating" />

			<div class="text-dark-300 dark:text-light-900 leading-tight my-1">
				{{ outcomeAdditionalInfo.TimeForm }}
			</div>
		</div>
		<div v-else class="text-center font-bold">
			{{ t("no-information-available") }}
		</div>
	</div>
</template>
